import { render, staticRenderFns } from "./EmployeeInSchool.vue?vue&type=template&id=56ba5ee2&scoped=true"
import script from "./EmployeeInSchool.vue?vue&type=script&lang=js"
export * from "./EmployeeInSchool.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInSchool.vue?vue&type=style&index=0&id=56ba5ee2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba5ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ba5ee2')) {
      api.createRecord('56ba5ee2', component.options)
    } else {
      api.reload('56ba5ee2', component.options)
    }
    module.hot.accept("./EmployeeInSchool.vue?vue&type=template&id=56ba5ee2&scoped=true", function () {
      api.rerender('56ba5ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/EmployeeInSchool.vue"
export default component.exports